import { Either, ParseResult, Schema } from "effect";

const boundaryOptions = { onExcessProperty: "error" as const };

/** Decode an unknown boundary value or throw an Effect parse error. */
export const decodeUnknownSync = <A, I>(
  schema: Schema.Schema<A, I, never>,
  input: unknown,
): A => Schema.decodeUnknownSync(schema, boundaryOptions)(input);

/** Decode an unknown boundary value without throwing. */
export const decodeUnknownEither = <A, I>(
  schema: Schema.Schema<A, I, never>,
  input: unknown,
): Either.Either<A, ParseResult.ParseError> =>
  Schema.decodeUnknownEither(schema, boundaryOptions)(input);

/** Return the decoded value when a boundary value is valid. */
export const decodeUnknownOption = <A, I>(
  schema: Schema.Schema<A, I, never>,
  input: unknown,
): A | undefined => {
  const decoded = decodeUnknownEither(schema, input);
  return Either.isRight(decoded) ? decoded.right : undefined;
};

/** Test whether an unknown value satisfies an Effect schema. */
export const isSchema = <A, I>(
  schema: Schema.Schema<A, I, never>,
  input: unknown,
): input is A => Either.isRight(decodeUnknownEither(schema, input));

/** Adapt an Effect schema to Standard Schema for Hono validation. */
export const standardSchema = <A, I>(schema: Schema.Schema<A, I, never>) =>
  Schema.standardSchemaV1(schema, boundaryOptions);
